export const updateProfessionalDetailsUpdateApi = (data) => {    
    return data.data;
}
export const userProfessionalInfoGetApi = (data) => {    
    return data.data;
}
export const roleListGetApi = (data) => {    
    return data.data;
}
export const roleDataUpdateApi = (data) => {    
    return data.data;
}